export default __webpack_public_path__ + "static/media/logout.bf0a9d15.svg";